import {
	SUBCATEGORIES_ROUTE_API,
	GET_LIST_SUBCATEGORIES,
	FETCHING_SUBCATEGORIES,
	GET_DETAIL_SUBCATEGORIES,
	UPDATE_SUBCATEGORIES,
	SUBCATEGORIES_ERROR,
	ADD_SUBCATEGORIES,
	NEW_SUBCATEGORIES,
	DELETE_SUBCATEGORIES,
	AUTH_TOKEN_KEY
} from '../constants';

import { logout } from './authAction';
import api from '../utils/Api';
import { manipulateErrors, checkAuthorized } from '../utils';

export const getSubcategoriesList = (query) => {
	return dispatch => (
		dispatch(isFetch({ type: 'fetch', status: true })),
		api({
			Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
		}).get(SUBCATEGORIES_ROUTE_API, query)
		.then(res => {
			dispatch(onSuccess(res.data, GET_LIST_SUBCATEGORIES));
			dispatch(isFetch({ type: 'fetch', status: false }));
		})
		.catch(err => {
			dispatch(onError(err));
			dispatch(isFetch({ type: 'fetch', status: false }));
		})
	);
};

export const getDetailSubcategories = (id) => {
	return dispatch => (
		dispatch(isFetch({ type: 'fetch', status: true })),
		api({
			Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
		}).get(`${SUBCATEGORIES_ROUTE_API}/${id}`)
		.then(res => {
			dispatch(onSuccess(res.data, GET_DETAIL_SUBCATEGORIES));
			dispatch(isFetch({ type: 'fetch', status: false }));
		})
		.catch(err => {
			dispatch(onError(err));
			dispatch(isFetch({ type: 'fetch', status: false }));
		})
	);
};

export const saveSubcategories = (payload) => {
	const { id, name, category_id, active } = payload;
	return dispatch => {
		if (payload.id === undefined)
			dispatch(createSubcategories({ name, category_id, active }));
		else
			dispatch(updateSubcategories(id, { name, category_id, active }));
	};
};

export const createSubcategories = (payload) => {
	return dispatch => (
		dispatch(isFetch({ type: 'submit', status: true })),
		api({
			Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
		}).post(SUBCATEGORIES_ROUTE_API, payload)
		.then(res => {
			dispatch(onSuccess(res.data, ADD_SUBCATEGORIES));
			dispatch(isFetch({ type: 'submit', status: false }));
		})
		.catch(err => {
			dispatch(onError(err));
			dispatch(isFetch({ type: 'submit', status: false }));
		})
	);
};

export const updateSubcategories = (id, payload) => {
	return dispatch => (
		dispatch(isFetch({ type: 'submit', status: true })),
		api({
			Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
		}).patch(`${SUBCATEGORIES_ROUTE_API}/${id}`, payload)
		.then(res => {
			dispatch(onSuccess(res.data, UPDATE_SUBCATEGORIES));
			dispatch(isFetch({ type: 'submit', status: false }));
		})
		.catch(err => {
			dispatch(onError(err));
			dispatch(isFetch({ type: 'submit', status: false }));
		})
	);
};

export const deleteSubcategories = (id) => {
	return dispatch => (
		dispatch(isFetch({ type: 'submit', status: true })),
		api({
			Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`
		}).delete(`${SUBCATEGORIES_ROUTE_API}/${id}`)
		.then(res => {
			dispatch(onSuccess(res.data, DELETE_SUBCATEGORIES));
			dispatch(isFetch({ type: 'submit', status: false }));
		})
		.catch(err => {
			dispatch(onError(err));
			dispatch(isFetch({ type: 'submit', status: false }));
		})
	);
};

export const isFetch = (payload) => ({
	type: FETCHING_SUBCATEGORIES,
	payload
});

export const onSuccess = (res, type) => ({
	type,
	payload: res
});

export const onError = (err) => {
	if (!checkAuthorized(manipulateErrors(err)))
		return logout();
	return {
		type: SUBCATEGORIES_ERROR,
		payload: manipulateErrors(err)
	};
};

export const newSubcategories = () => ({
	type: NEW_SUBCATEGORIES
});
